import * as React from 'react';
import { getSystemUsers } from '@/api/accounts';
import { useQuery } from '@tanstack/react-query';

import { useUser } from '@/hooks/v2/use-user';

import { SystemUsersTable } from './components/system-users-table';

export function AccountSystemUsersPage(): React.JSX.Element {
  const { account } = useUser();
  
  if (!account) {
    return <div>No account found</div>;
  }

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['system-users', account?.id],
    queryFn: async () => await getSystemUsers(account?.id),
  });

  const users = data?.systemUsers;

  return <SystemUsersTable loading={isLoading} rows={users ?? []} />;
}
